import Summary, { ISummaryPrice } from "./submodules/summary/summary";
import axios from 'axios';

export default class Order {
  private Summary: Summary = new Summary();

  // Amount of choosed slots
  protected slots: number = 0;

  // Value of the selected location
  protected location: number = 0;

  // Duration
  protected duration: { amount: number, id: number } = { amount: 0, id: 0 };

  // Choosed gameid
  protected gameId: number = 0;

  public constructor() {
    this.duration = {
      id: $(".input-duration:checked").val() as number,
      amount: $(".input-duration:checked").data('amount')
    };
    this.gameId = Number($('.input-location:checked').val().toString().replace(/^[0-9]+\//, ''));
    this.onUpdate();
  }

  public setSlots(amount: number) {
    this.slots = amount;
    this.onUpdate();
  }

  public setLocation(location: number) {
    this.location = location;
    this.onUpdate();
  }

  public setGameId(gameId: number) {
    this.gameId = gameId;
    this.onUpdate();
  }

  public setDuration(duration: {amount: number, id: number}) {
    this.duration = duration;
    this.onUpdate();
  }

  private onUpdate() {
    this.Summary.slots = this.slots;
    this.Summary.location = this.location;
    this.Summary.duration = this.duration
    this.Summary.gameId = this.gameId;

    this.getPrice().then((data) => {
      this.Summary.price = data;
      this.Summary.render();
    });
  }

  private getPrice() : Promise<ISummaryPrice> {
    this.Summary.enableLoading();
    return new Promise((resolve, reject) => {
      axios.get(window.basePath + window.regionPrefix + `/order/getPrice/${window.productIdent}/${this.slots}/${this.duration.id}`).then((response) => {
        resolve(response.data);
        this.Summary.disableLoading();
      });
    })
  }
}

export function initOrder() {
  if ( $("*[data-order]").length > 0 ) {
    return new Order();
  }
}
